import { createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../../shared/utils/api.js'

export const fetchProperties = createAsyncThunk('properties/fetch', async (_, { rejectWithValue }) => {
  try {
    let allProperties = []
    let currentPage = 1
    let totalPages = 1

    do {
      const response = await api.get(`/v1/properties?page=${currentPage}&limit=20`)
      const { properties, total, limit } = response.data
      allProperties = [...allProperties, ...properties]
      totalPages = Math.ceil(total / limit)
      currentPage++
    } while (currentPage <= totalPages)

    return allProperties
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const fetchProperty = createAsyncThunk('property/fetch', async (propertyId, { rejectWithValue }) => {
  try {
    const response = await api.get(`/v1/properties/${propertyId}`)
    return response.data
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const fetchPropertiesbyAgent = createAsyncThunk('agentproperty/fetch', async (agentId, { rejectWithValue }) => {
  console.log('agentId:', agentId)
  try {
    const response = await api.get(`/v1/properties/by-agent/${agentId}`)
    console.log('response:', response.data)
    return response.data.properties
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const savedProperties = createAsyncThunk('property/savedProperties', async (_, { rejectWithValue }) => {
  console.log('saved properties from Redux:')
  try {
    let allProperties = []
    let currentPage = 1
    let totalPages = 1

    do {
      const response = await api.get('/v1/bookings/admin/saved-properties', {
        params: { page: currentPage },
      })
      const { savedProperties, pagination } = response.data

      allProperties = [...allProperties, ...savedProperties]

      totalPages = pagination.totalPages
      currentPage++
    } while (currentPage <= totalPages)
    console.log('saved properties from Redux:', allProperties)
    return allProperties
  } catch (error) {
    return rejectWithValue(error.response.data.message || error.message)
  }
})

export const createProperty = createAsyncThunk('property/create', async propertyData => {
  const response = await api.post('/v1/properties', propertyData)
  return response.data
})

export const updateProperty = createAsyncThunk(
  'property/update',
  async ({ propertyId, updatedData }, { rejectWithValue }) => {
    try {
      const response = await api.patch(`/v1/properties/update/${propertyId}`, updatedData)
      return response.data.property
    } catch (error) {
      return rejectWithValue(error.response.data.message || error.message)
    }
  }
)

export const deleteProperty = createAsyncThunk('property/delete', async propertyId => {
  const response = await api.delete(`/v1/properties/delete/${propertyId}`)
  return response.data
})
